import React from 'react';
import {Grid, Input, Dropdown, Popup, Icon} from 'semantic-ui-react';
import {setErrorMessage, clearErrorMessage} from '../../../../../common/components/form/common';
import {priorities} from '../../../../../common/dictionaries/forms';
import {Label} from './common/index';

function getPriorityOptions() {
  return Object.keys(priorities).map((item) => {
    return {'text': priorities[item], 'value': item};
  });
}

function getAgenciesOptions(agenciesList) {
  return agenciesList.map((item) => {
    return {'text': item.name, 'value': item.code};
  });
}

const FtrValue = ({formNumber}) => {
  return (
    <Grid.Column width={1} className='form-number'>
      {formNumber}
    </Grid.Column>
  );
};

const GeneralInfoRow = ({
  loadingAgencies,
  generalInfo,
  isDisplayMode,
  formNumber,
  type,
  agenciesList,
  onChangeValue,
  onChangeInputField,
}) => {
  return (
    <Grid.Row>
      <Label width={2} label='Concesionario' />
      <Grid.Column width={3} className='dealer-container'>{generalInfo.dealerName}</Grid.Column>
      <Label width={1} label='Agencia' />
      <Grid.Column width={3} className='agency-container'>
        <Dropdown
          selection
          options={getAgenciesOptions(agenciesList)}
          search
          value={generalInfo.agencyCode}
          disabled={loadingAgencies || isDisplayMode}
          loading={loadingAgencies}
          onChange={(e, {value, options}) =>
            onChangeValue('agencyCode', value, options)
          }
          placeholder='Seleccione Agencia'
        />
      </Grid.Column>
      <Label width={1} label='Año' />
      <Grid.Column width={1} className='year-container'>
        <Input
          type='text'
          value={generalInfo.year || ''}
          onChange={(e, {value}) => onChangeInputField('year', value)}
          onInvalid={(event) =>
            setErrorMessage('Por favor, llene este campo', event)
          }
          onInput={(event) => clearErrorMessage(event)}
          disabled={isDisplayMode}
          placeholder='Año'
          autoComplete='off'
        />
      </Grid.Column>
      <Label width={1} label='Prioridad' />
      <Grid.Column width={2} className='priority-container'>
        <Dropdown
          selection
          options={getPriorityOptions()}
          value={generalInfo.priority}
          onChange={(e, {value}) => onChangeValue('priority', value)}
          disabled={isDisplayMode}
          placeholder='Prioridad'
        />
        <Popup
          trigger={<Icon link name='info circle' color='blue' size='big' />}
          on='click'
          position='bottom left'
          inverted
        >
          <div>texto</div>
        </Popup>
      </Grid.Column>
      {formNumber && <Label width={1} label={`${type} No.`} />}
      <FtrValue formNumber={formNumber} />
    </Grid.Row>
  );
};

export default GeneralInfoRow;
